import { NTA_PALETTE_ICON } from './Instructions/ntaInstructionsContent';

/** Maps live question status to the same legend icon type. */
export const getNtaPaletteIconFromStatus = ({
  isMarkedAndAttempted,
  isMarked,
  isAttempted,
  isUnanswered
}) => {
  if (isMarkedAndAttempted) {
    return NTA_PALETTE_ICON.ANSWERED_MARKED;
  }
  if (isMarked) {
    return NTA_PALETTE_ICON.MARKED_FOR_REVIEW;
  }
  if (isAttempted) {
    return NTA_PALETTE_ICON.ANSWERED;
  }
  if (isUnanswered) {
    return NTA_PALETTE_ICON.NOT_ANSWERED;
  }
  return NTA_PALETTE_ICON.NOT_VISITED;
};

export const NTA_PALETTE_LIGHT_TEXT_ICONS = new Set([
  NTA_PALETTE_ICON.NOT_ANSWERED,
  NTA_PALETTE_ICON.ANSWERED,
  NTA_PALETTE_ICON.MARKED_FOR_REVIEW,
  NTA_PALETTE_ICON.ANSWERED_MARKED
]);
